export const INVITE_PASSWORD_MIN_LENGTH = 12;

export function invitePasswordError(
  password: string,
  confirm: string,
): string | null {
  const next = password.trim();
  if (next.length < INVITE_PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${INVITE_PASSWORD_MIN_LENGTH} characters.`;
  }
  if (next !== confirm) {
    return 'Passwords do not match.';
  }
  return null;
}

export function buildInvitePasswordAcceptRequest(
  inviteId: string,
  password: string,
  confirm: string,
):
  | { ok: false; error: string }
  | { ok: true; payload: { inviteId: string; newPassword: string } } {
  const error = invitePasswordError(password, confirm);
  if (error) return { ok: false, error };
  return { ok: true, payload: { inviteId, newPassword: password.trim() } };
}

/** Hide raw Firebase codes like auth/invalid-credential on the invite page. */
export function inviteAcceptErrorMessage(err: unknown): string {
  const e = err as { code?: string; message?: string };
  const code = typeof e?.code === 'string' ? e.code : '';
  if (
    code === 'auth/invalid-credential'
    || code === 'auth/wrong-password'
    || code === 'auth/user-not-found'
    || code === 'auth/invalid-login-credentials'
  ) {
    return 'That password does not match the temporary password in the invite email. Ask Leiper\'s Creek Timber Frames to resend the invite if you need a new one.';
  }
  const raw = typeof e?.message === 'string' ? e.message : '';
  if (/auth\/invalid-credential|auth\/wrong-password|auth\/invalid-login-credentials/i.test(raw)) {
    return 'That password does not match the temporary password in the invite email. Ask Leiper\'s Creek Timber Frames to resend the invite if you need a new one.';
  }
  const message = raw.replace(/^Firebase:\s*/i, '').replace(/\s*\(auth\/[a-z0-9-]+\)\s*/gi, ' ').trim();
  return message || 'Could not accept the invite.';
}
